import React, { useState } from 'react';
import './recpassword.css';
import Navbar from '../../components/navbar';
import firebase from '../../config/firebase';
import 'firebase/auth';
import {Link} from 'react-router-dom';

function RecPassword(){

    const [email, setEmail] = useState();
    const [msg, setMsg] = useState();

    function recuperarSenha(){
        firebase.auth().sendPasswordResetEmail(email).then(resultado => {
            setMsg('Enviamos um link no seu email para você redefinir sua senha.');
        }).catch(erro => {
            setMsg('Verifique se o email está correto.');
        })
    }

    return(
        <>
            <main className="form-signin">
                <form className="text-center form-login mx-auto mt-5 inner-form">                
                    <h1 className="mb-3 font-weight-bold">Recuperar Senha</h1>
                    <input onChange={(e) => setEmail(e.target.value)} type="email" className="form-control my-2" placeholder="Email" />

                    <div className="msg my-4 text-center">
                        <span>{msg}</span>
                    </div>
                    <Link className="nav-link" to="/home"><i className="bi bi-house-door"></i></Link>

                    <button onClick={recuperarSenha} type="button" className="btn btn-lg btn-block btn-enviar">Recuperar Senha</button>
                </form>
            </main>
        </>        
    )
}

export default RecPassword;